import React from "react";
import { Group, Rect, Text } from "react-konva";
import { IMondayTaskController } from "../../controller";
import {
  MondayTaskSection,
  MONDAY_TASK_WIDTH,
  MONDAY_TASK_FILES_ROW_HEIGHT,
  MONDAY_TASK_DYNAMIC_SECTION_PADDING,
} from "shared/datamodel/monday-task";
import { FONT_SIZE, FONT_FAMILY, PADDING } from "../../consts";
import useObservableController from "elements/hooks/use-observable-controller";
import { FileRow } from "./file-row";

interface FilesProps {
  controller: IMondayTaskController;
}

const ROW_HEIGHT = MONDAY_TASK_FILES_ROW_HEIGHT;
const TEXT_COLOR = "#7F869B";
const LETTER_SPACING = 0.1824;
const TITLE_WIDTH = 40;
const GAP = 10;
const MAX_FILE_NAME_WIDTH = MONDAY_TASK_WIDTH - PADDING * 2 - TITLE_WIDTH - GAP;

export const Files = React.memo(({ controller }: FilesProps) => {
  useObservableController(controller, [
    "item-changed",
    "board-columns-changed",
    "file-visibility-changed",
    "size-changed",
  ]);

  const y = controller.getSectionY(MondayTaskSection.FILES);
  const allFiles = controller.files();

  // Don't render if no files
  if (allFiles.length === 0) {
    return null;
  }

  return (
    <Group y={y}>
      <Rect width={MONDAY_TASK_WIDTH} height={1} fill="#EBEDF3" />

      <Group x={PADDING} y={MONDAY_TASK_DYNAMIC_SECTION_PADDING}>
        <Text
          text="Files:"
          fill={TEXT_COLOR}
          fontFamily={FONT_FAMILY}
          fontSize={FONT_SIZE}
          letterSpacing={LETTER_SPACING}
          width={TITLE_WIDTH}
          wrap="none"
          ellipsis
        />

        <Group x={TITLE_WIDTH + GAP}>
          {allFiles.map((file, index) => (
            <FileRow
              key={file.id}
              file={file}
              controller={controller}
              y={index * ROW_HEIGHT}
              maxFileNameWidth={MAX_FILE_NAME_WIDTH}
            />
          ))}
        </Group>
      </Group>
    </Group>
  );
});

Files.displayName = "Files";
